<template>
    <div>
        <el-card class="box-card">
            <el-form :model="opinion" ref="searchRef" label-width="40px">
                <el-form-item label="问题" class="addAdminForm">
                    <el-input type="textarea" v-model="opinion.question" placeholder="请输入问题" rows="15"></el-input>
                </el-form-item>
                <el-form-item label="解答" class="addAdminForm">
                    <el-input type="textarea" v-model="opinion.answer" placeholder="请输入解答" rows="15"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="clicksave">提交</el-button>
                    <el-button type="info" @click="backQa">返回</el-button>
                </el-form-item>
            </el-form>

        </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      opinion: {
        question: '',
        answer: ''
      },
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.opinion.question = this.parentdata.params.question
      this.opinion.answer = this.parentdata.params.answer
    },
    backQa () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditQa()
    },
    apiEditQa: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        qaid: that.parentdata.params.qaid,
        question: that.opinion.question,
        answer: that.opinion.answer
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditQa, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
